const ArticleSubTitle = ({ title, subTitle, textColor, link, onClick, isActive }) => {
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`right-item${isActive ? " active" : ""}`}
        style={{ color: textColor }}
      >
        <p className="right-title font-amaticsc-bold">{title}</p>
        <p className="right-sub-title font-zenkurenaido">{subTitle}</p>
      </button>
    );
  }

  const Wrapper = link ? "a" : "div"; // dynamic tag
  const props = link ? { href: `#${link}`, className: "right-item" } : { className: "right-item" };

  return (
    <Wrapper {...props} style={{ color: textColor }}>
      <p className="right-title font-amaticsc-bold">{title}</p>
      <p className="right-sub-title font-zenkurenaido">{subTitle}</p>
    </Wrapper>
  );
};

export default ArticleSubTitle;
